/**
 * Shopify Product Recommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            if (typeof Swiper !== "undefined") {
              const swiperElement = document.querySelector(
                ".products-recommendations-swiper"
              );
              if (swiperElement) {
                new Swiper(".products-recommendations-swiper",
                {
                  slidesPerView: 1.5,
                  spaceBetween: 8,
                  freeMode: true,
                  slidesOffsetBefore: 12,
                  slidesOffsetAfter: 12,
                  scrollbar: {
                  	el: '.swiper-scrollbar',
                  	hide: false
                  },
                  navigation: {
                  	nextEl: '.swiper-button-next',
                  	prevEl: '.swiper-button-prev'
                  },
                  breakpoints: {
                  	768: {
                  		slidesPerView: 2.5,
                  		spaceBetween: 12,
                  		slidesOffsetBefore: 12,
                  		slidesOffsetAfter: 12
                  	},
                  	1200: {
                  		slidesPerView: 3.5,
                  		spaceBetween: 12,
                  		slidesOffsetBefore: 12,
                  		slidesOffsetAfter: 12
                  	},
                  	1400: {
                  		slidesPerView: 4,
                  		spaceBetween: 12,
                  		slidesOffsetBefore: 0,
                  		slidesOffsetAfter: 0
                  	}
                  }
                });
              }
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);